export const MONTHLY_CLOSING_LABELS = {
  title: "Cierre Mensual Comisionistas",
  headers: {
    customerName: "Cliente",
    retentions: "Retenciones",
    advances: "Anticipos",
    others: "Otros",
    close: "Cierre",
    monthlyTotal: "Saldo Mensual",
    actions: "Acciones",
    createdDate: "Fecha Creación",
    expense: "Gasto",
    amount: "Importe",
  },
  tooltips: {
    newMovement: "Nuevo",
    close: "Cerrar",
  },
  modals: {
    expensesDetail: "Otros Gastos",
    manualClose: "Cierre Mensual Manual",
    otherClose: "Cierre Otros",
    movements: "Movimientos",
  },
  filters: {
    month: "Mes",
    year: "Año",
    noOptions: "Sin opciones",
  },
  buttons: {
    create: "Crear",
  },
  summary: {
    total: "Total:",
    retentionBalance: "Saldo Total de Retención:",
  },
  messages: {
    selectStation: "Selecciona una planta",
  },
};
